import Vue from "vue";
import Vuex from "vuex";
import VeeValidate from "vee-validate";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import { store } from "./services/store.js";
import VueCurrencyInput from "vue-currency-input";
import VueLazyload from "vue-lazyload";
import BootstrapVue from "bootstrap-vue";
// import styleConst from "./components/common/constants/StyleConst.module.scss";

import rightsConstantArray from "./services/constants.js";
import statusConstant from "./services/statusConstants.js";
import { GridPlugin } from "@syncfusion/ej2-vue-grids";
import {
  MultiSelectPlugin,
  DropDownTreePlugin
} from "@syncfusion/ej2-vue-dropdowns";
import { TabPlugin } from "@syncfusion/ej2-vue-navigations";
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import fullCalendar from "vue-fullcalendar";
import Print from "vue-print-nb";
import resetLocale from "~/components/localization/datePickerLocale.js";
Vue.component("full-calendar", fullCalendar);
Vue.use(DatePickerPlugin);
Vue.use(GridPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(TabPlugin);
Vue.use(Print);
Vue.use(DropDownTreePlugin);
Vue.prototype.rightsConstant = rightsConstantArray;
Vue.prototype.statusConstant = statusConstant;
// Vue.prototype.styleConst = styleConst;
Vue.use(Vuex);
Vue.use(resetLocale);
console.log("resetLocale", resetLocale);
// Vue.use(VeeValidate);
Vue.use(VeeValidate, {
  fieldsBagName: "formFields",
  useConstraintAttrs: false
});
Vue.use(VueCurrencyInput);
Vue.use(VueLazyload);
Vue.use(BootstrapVue);

Vue.filter("toFixedDecimal", value => {
  if (value !== null && value !== undefined && value !== "") {
    return value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
  }
});
Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his children
      if (
        !(el == event.target || el.contains(event.target)) &&
        typeof vnode.context[binding.expression] === "function"
      ) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});
new Vue({
  el: "#app",
  store,
  router,
  vuetify: vuetify,
  beforeCreate() {
    Vue.prototype.$bus = this; // 安装全局事件总线
  },
  render: h => h(App)
});
